export default __webpack_public_path__ + "static/media/gl.95973d53.svg";